import i18n from 'i18next';
import { IUiDataService } from '@src/slide/domain/ui-model/service/ui-data-service.interface';
import { SlideInterface } from '@tencent/docs-api';
import {
    IElementNode,
    ISlideNode,
    ITextElementBoxNode,
} from '../../slide-content-enumerator/enumerator-types.interface';
import { BaseAnalyzer } from '../base/base-analyzer';
import { ColorBaseAnalyzer } from '../../slide-rating-and-improve/base/color-base-analyzer';
import { IColorAnalysisResult } from '../../slide-rating-and-improve/base/color-base-analyzer.interface';
import { IPresentationModel } from '@src/slide/domain/ui-model/element-modeles/Interface/presentation-model.interface';

type IResult = SlideInterface.CheckResultItem;

export class MachineColorAnalyzer extends BaseAnalyzer<IResult> {
    private title = i18n.t('文字颜色对比度检测');
    private description = i18n.t('检查文字颜色对比度，判断其在视觉上是否可以看清');
    private level = 'warning' as const;
    private anchorType = 'element' as const;

    private colorAnalyzer: TextColorAnalyzer;

    public constructor(private uiDataService: IUiDataService) {
        super();
        this.colorAnalyzer = new TextColorAnalyzer();
    }

    public onPresentationStart(): void {
        this.colorAnalyzer.resetWithPresentation(this.uiDataService.presentation);
    }

    public onSlideStart(node: ISlideNode): void {
        this.colorAnalyzer.analysisSlide(node.slide);
    }

    public onElement(element: IElementNode): void {
        this.colorAnalyzer.analysisElement(element);
    }

    public onTextElementBox(textElementBoxNode: ITextElementBoxNode): void {
        this.colorAnalyzer.analysisTextElementBox(textElementBoxNode);
    }

    public async calculateResult(): Promise<IResult> {
        const { title, description } = this;
        const errorMessages: SlideInterface.CheckErrorMessage[] = [];
        await this.colorAnalyzer.addAnalysisResult();
        // eslint-disable-next-line no-restricted-syntax
        for (const item of this.colorAnalyzer.result) {
            if (item.contrast < 1.6 && errorMessages.every(i => i.anchor !== item.boxNode.element)) {
                errorMessages.push({
                    level: this.level,
                    anchorType: this.anchorType,
                    anchor: item.boxNode.element,
                    description: i18n.t(`元素文字[${item.boxNode.textBox.text}]对比度太低`),
                });
            }
        }
        const passed = errorMessages.length <= 0;
        if (passed) {
            return { passed, title, description };
        }
        return { passed, title, description, errorMessages };
    }
}

class TextColorAnalyzer extends ColorBaseAnalyzer {
    protected analysisImage = true;
    private colorResult: IColorAnalysisResult[];

    public constructor() {
        super();
    }

    public get result() {
        return this.colorResult;
    }

    public resetWithPresentation(presentation: IPresentationModel) {
        super.resetWithPresentation(presentation);
        this.colorResult = [];
    }

    public async addAnalysisResult(): Promise<void> {
        const results = this.calculateResult();
        // eslint-disable-next-line no-restricted-syntax
        for (const result of results) {
            this.colorResult.push(await result);
        }
    }
}
